import React from 'react';
import { useLocation } from 'react-router';
import { NavLink as RouterLink } from 'react-router-dom';
//import makeStyles from '@mui/styles/makeStyles';
import { useTheme, styled } from '@mui/material/styles';
import {
  Divider,
  Drawer,
  IconButton,
  List,
  Typography,
  CssBaseline,
  ListItem,
  ListItemText
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import {
  DashboardOutlined,
  BusinessCenterOutlined,
  EqualizerOutlined,
  LocalShippingOutlined,
  MonetizationOnOutlined,
  PeopleOutlineOutlined,
  PowerSettingsNewOutlined,
  ReceiptOutlined,
  SettingsApplicationsOutlined,
  TrainOutlined,
  ContactSupportOutlined,
} from '@mui/icons-material';
import { deepOrange } from '@mui/material/colors';
import { logoutUser } from 'services/login-service';
import { connect } from 'react-redux';

const drawerWidth = 200;

const DrawerStyled = styled(Drawer, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  '& .MuiDrawer-paper': {
    width: open ? drawerWidth : theme.spacing(7) + 1,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: open ? theme.transitions.duration.enteringScreen : theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    backgroundColor: '#000',
    color: '#fff',
    [theme.breakpoints.up('sm')]: {
      width: open ? drawerWidth : theme.spacing(8) + 1,
    },
  },
}));

const ToolbarStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const RootContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
});

const AvatarStyled = styled('div')(({ theme }) => ({
  color: theme.palette.getContrastText(deepOrange[500]),
  backgroundColor: deepOrange[500],
  marginTop: 5,
  marginBottom: 20,
  marginLeft: 8,
}));

const handleLogout = (evt) => {
  evt.preventDefault();
  logoutUser().then(() => {
    setTimeout(() => {
      window.location.href = '/';
    }, 1000);
  });
};

const MenuDrawer = (props) => {
  const { tenantBusinessModel } = props.tenant;

  const intermodalDashboard = {
    href: '/app/intermodal',
    title: 'Intermodal',
    icon: <TrainOutlined />,
  };

  const otrDashboard = {
    href: '/app/longhaul',
    title: 'OTR Dispatch',
    icon: <DashboardOutlined />,
  };

  const menuItems = [
    { href: '/app/brokers', title: 'Brokers', icon: <PeopleOutlineOutlined /> },
    { href: '/app/companies', title: 'Companies', icon: <BusinessCenterOutlined /> },
    { href: '/app/equipments', title: 'Equipments', icon: <LocalShippingOutlined /> },
    { href: '/app/drivers', title: 'Drivers', icon: <PeopleOutlineOutlined /> },
    { href: '/app/accounting', title: 'Accounting', icon: <ReceiptOutlined /> },
    { href: '/app/paymanager', title: 'Driver Settlement', icon: <MonetizationOnOutlined /> },
    { href: '/app/dashboard', title: 'Dashboard', icon: <EqualizerOutlined /> },
    { href: '/app/profile', title: 'My Profile', icon: <SettingsApplicationsOutlined /> },
    { href: '/', title: 'Logout', icon: <PowerSettingsNewOutlined /> },
    { href: '/app/support', title: 'Help & Support', icon: <ContactSupportOutlined /> },
  ];

  if (tenantBusinessModel === 'INTERMODAL') {
    menuItems.unshift(intermodalDashboard);
  } else if (tenantBusinessModel === 'OTR') {
    menuItems.unshift(otrDashboard);
  } else {
    menuItems.unshift(otrDashboard, intermodalDashboard);
  }

  const location = useLocation();
  //const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setOpen(!open);
  };

  return (
    <RootContainer>
      <CssBaseline />
      <DrawerStyled variant="permanent" open={open}>
        <ToolbarStyled>
          <IconButton color="secondary" onClick={handleDrawerToggle} size="large">
            {theme.direction === 'rtl' ? <ChevronRightIcon /> : <MenuIcon />}
          </IconButton>
        </ToolbarStyled>
        <Divider style={{ backgroundColor: '#fff' }} />
        <List>
          {menuItems.map((item) => (
            <ListItem
              key={item.title}
              button
              component={RouterLink}
              to={item.href}
              selected={item.href === location.pathname}
            >
              {item.title === 'Logout' ? (
                <ListItemText onClick={handleLogout}>{item.icon}</ListItemText>
              ) : (
                <ListItemText>{item.icon}</ListItemText>
              )}
              {open && (
                <ListItemText>
                  <Typography variant="h5">{item.title}</Typography>
                </ListItemText>
              )}
            </ListItem>
          ))}
        </List>
      </DrawerStyled>
    </RootContainer>
  );
};

function mapStatesToProps(state) {
  const { tenant, user } = state.tenantReducer;
  return {
    tenant,
    user,
  };
}

// Promote BrokerPage from a component to a container - it needs to know
// about this new dispatch method, selectBroker
export default connect(mapStatesToProps,  null)(MenuDrawer);